export default "__VITE_ASSET__f28f19d0__"